"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = require("react-dom");
function getContainer(container, defaultContainer) {
    container = typeof container === 'function' ? container() : container;
    return container && ReactDOM.findDOMNode(container) || defaultContainer;
}
exports.getContainer = getContainer;
